import { render, staticRenderFns } from "./bodyCation.vue?vue&type=template&id=525c9800&scoped=true&"
import script from "./bodyCation.vue?vue&type=script&lang=js&"
export * from "./bodyCation.vue?vue&type=script&lang=js&"
import style0 from "./bodyCation.vue?vue&type=style&index=0&id=525c9800&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c9800",
  null
  
)

export default component.exports